import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'
import Storage from "@/utils/storage.js"
import{ timeLoding} from "@/utils/index"
const refreshTokenTime = 7200

const service = axios.create({
  baseURL:(process.env.NODE_ENV==='production'?process.env.VUE_APP_BASE_API_URL:'')+"/23s3-dgmedia-zkt-backend", 
  timeout: 20000,
})

// 请求拦截器,需求,如果是用户一直用的情况才,才会无痛刷新token,如果超过2个小时内没有用的了,就会自动退出登录
service.interceptors.request.use(config => {
    timeLoding.open(config)
    if (store.getters.token) {
      if (getdDiffTime() > refreshTokenTime) {
        store.dispatch('user/logout')
        Message.error('登录超时了')
        timeLoding.reset()
        return Promise.reject(new Error('token超时了'))
      }else {
        config.headers['X-Access-Token'] = `${store.getters.token}`
      }
    }
    return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(response => {
  timeLoding.close(response.config.url, service._requestTimeIdList)
  const { code, message, data ,success  } = response.data
  if (success) {
    return data||response.data.result
  }else {
    Message.error(message||'接口报错') 
    return Promise.reject(new Error(message))
  }
}, error => {
  const {status} = error.response
  if(status === 401){
    store.dispatch('user/logout')
    Message.error('登录失效,请重新登录')
  }
  if(error.code === 'ECONNABORTED'){
    Message.error("数据响应超时,请重试")
  }
  if(error.code === 'Network Error'){
    Message.error("当前无网络,请检查网络连接")
  }
  if(error.response){
    Message.error(error.response.data.message||'服务器接口异常，请联系管理员') 
  }
  timeLoding.reset()
  return Promise.reject(error)
})

// 超时逻辑  (当前时间  - 缓存中的时间) 是否大于 时间差
function getdDiffTime() {
  var currentTime = Date.now() 
  var timeStamp = Storage.getTimeStamp() 
  const diffTime = Math.trunc((currentTime - timeStamp) / 1000)
  return diffTime
}

export default service


